export function init($name) {
    if (!$($name).length) {
        return;
    }

    let slider = $($name + '-slider');
    let menu = $($name + '-hld');
    let menuSec = $($name + '-secondary');
    let menuChilds = menu.children('#main-menu').children();

    let spaceSlider = 10;

    let hasActive = null;

    menuChilds.each(function () {
        if ($(this).hasClass('current-menu-item') || $(this).hasClass('current-menu-parent') || $(this).hasClass('current-menu-ancestor')) {
            slider.css({
                'left': $(this).offset().left - spaceSlider / 2,
                'width': $(this).width() + spaceSlider,
                'opacity': 1
            });
            hasActive = $(this);
        }
    });

    menuChilds.mouseenter(function () {
        slider.css({
            'left': $(this).offset().left - spaceSlider / 2,
            'width': $(this).width() + spaceSlider,
            'opacity': 1
        });

        if (
            ($(this).hasClass('special-hover-action-careers') && $(this).hasClass('current_page_item')) ||
            ($(this).hasClass('special-hover-action-careers') && $(this).hasClass('current-menu-ancestor'))
        ) {
            return;
        }

        if ($(this).hasClass('menu-item-has-children') && !$(this).hasClass('current-menu-item')) {
            menuSec.addClass('is-moved');
        }
    });

    menuChilds.mouseleave(function () {
        menuSec.removeClass('is-moved');

        if (hasActive) {
            slider.css({
                'left': hasActive.offset().left - spaceSlider / 2,
                'width': hasActive.width() + spaceSlider,
                'opacity': 1
            });
        } else {
            slider.css('opacity', 0);
        }
    });

    $('.js-menu-indicator-hld > ul > li').mouseenter(function() {
       if ($(this).hasClass('current-menu-item') || $(this).hasClass('current-page-ancestor') || $(this).hasClass('current-menu-ancestor')) {
           return;
       }

       $('.js-menu-indicator-secondary').addClass('is-moved');
    });

    $('.js-menu-indicator-hld > ul > li').mouseleave(function() {
       $('.js-menu-indicator-secondary').removeClass('is-moved');
    });

    $('.js-menu-indicator-hld > ul > li.menu-item-has-children > a').each(function() {
       $(this).clone().prependTo($(this).next());
    });
}


export function recalculate($name) {
    if (!$($name).length) {
        return;
    }

    let slider = $($name + '-slider');
    let menu = $($name + '-hld');
    let menuChilds = menu.children('#main-menu').children();

    let spaceSlider = 10;

    menuChilds.each(function () {
        if ($(this).hasClass('current-menu-item') || $(this).hasClass('current-menu-parent') || $(this).hasClass('current-menu-ancestor')) {
            slider.css({
                'left': $(this).offset().left - spaceSlider / 2,
                'width': $(this).width() + spaceSlider,
                'opacity': 1
            });
        }
    });
}
